export const impactData = [
    {
        sectionTitle: "Broader Impact",
        impactList: [
            {
                subtitle: "Social and Technological Impact beyond Service Conflicts",
                detail: `
The theory and models we proposed have potential impacts beyond smart city service conflict management to address the fundamental systems-of-systems challenge in multi-stakeholder open environments where
* each uncertain interaction (e.g., conflicts) between systems can be modeled as a task;
* the detection/resolution process of one interaction improves the process of other correlated interactions.

Thus, its potential impacts go beyond smart city services for use cases with a generic setting of systems-of-systems with uncertain conflicts such as
* Smart rural communities
* Transportation systems
* Power grids  
* Agriculture
* Healthcare
                `,
            },
            {
                subtitle: "Education",
                detail: `
This project will support a few education activities well-integrated with the proposed research by working with our non-profit collaborators at  Black Data Processing Associates and ASPIRA Inc, such as​
* Education and Technology Dissemination Session Newark Community
* Graduate and Undergrad Courses
* K-12 Summer Research Program 
* Female & Minority 
                `,
            },
        ],
    }
];